module.exports = __webpack_public_path__ + "static/media/awl-paywall-header.e832a2d6.png";